// 在线评估-首页
<template>
  <div class="coe-home">
    <div class="user-unreadable" v-if="!showPageF">
      <div class="tips-box">
        {{ unreadableTips }}
      </div>
    </div>
    <estPage
      v-if="showPageF && onShowPageType === '在线评估'"
      :showPageFP="showPageF"
      :estActiveStepLabelP="estActiveStepLabel"
      :estActiveStepPathP="estActiveStepPath"
      :activeMenuListP="activeMenuList"
      :activeHomePageP="activeHomePage"
    ></estPage>
    <estSystemPage
      v-if="showPageF && onShowPageType === '系统管理'"
      :showPageFP="showPageF"
      :estActiveStepLabelP="estSysActiveStepLabel"
      :estActiveStepPathP="estSysActiveStepPath"
      :activeMenuListP="activeMenuList"
      :activeHomePageP="activeHomePage"
    ></estSystemPage>
    <!-- <div class="user-box" style="display:none;">
      <div class="action">
        <div class="my-name" :title="userName ? userName : '未登录'">
          {{ userName ? userName + '，欢迎回来' : '未登录'}}
        </div>
      </div>
    </div>
    <div class="index-main" style="display:none;">
      <div class="index-main-center-box">
        <div class="box-btn" @click="goMainInner('在线评估')">
          <i class="box-btn-icon el-icon-s-order"></i>
          <div class="box-btn-label">在线评估</div>
        </div>
        <div class="box-btn" @click="goMainInner('系统管理')">
          <i class="box-btn-icon el-icon-s-tools"></i>
          <div class="box-btn-label">系统管理</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import api from '../../../api/indexForCoe'
import estPage from '../coe-com/estPage.vue'
import estSystemPage from '../coe-com/estSystemPage.vue'
// import protectionMap from '../../../src/H5pages/protectionMap'
export default {
  data () {
    return {
      showPageF: false,
      unreadableTips: '您没有进入该页面的权限，请联系管理员处理。开启权限后，重启应用即可进入。',
      onShowPageType: '在线评估',
      phone: '',
      userName: '',
      activeHomePage: '',
      activeMenuList: [],
      enterableInnerList: [],
      estAllStepLabel: [
        '汇总',
        '受理',
        '待分配',
        '待评估',
        '会议通知',
        '评估',
        '审核',
        '审定',
        '存档'
      ],
      estAllStepPath: [
        '/estOverview',
        '/estEia',
        '/estAllocation',
        '/estMeeNotice',
        '/estExaApp',
        '/estEst',
        '/esTexamine',
        '/esTauthorize',
        '/estSave'
      ],
      estActiveStepLabel: [],
      estActiveStepPath: [],
      estSysAllStepLabel: [
        '人事中心'
      ],
      estSysAllStepPath: [
        '/estPerCenter'
      ],
      estSysActiveStepLabel: [],
      estSysActiveStepPath: [],
      menuList: [{
        id: 6,
        index: '',
        content: '在线评估',
        showFlag: 0,
        children: [{
          id: 1,
          index: '/estOverview',
          content: '汇总',
          showFlag: 0
        }, {
          id: 7,
          index: '/estEia',
          content: '受理',
          showFlag: 0
        }, {
          id: 17,
          index: '/estAllocation',
          content: '待分配',
          showFlag: 0
        // }, {
        //   id: 8,
        //   index: '/estAcceptance',
        //   content: '预审核',
        //   showFlag: 0
        }, {
          id: 9,
          index: '/estMeeNotice',
          content: '待评估',
          showFlag: 0
        }, {
          id: 10,
          index: '/estExaApp',
          content: '会议通知',
          showFlag: 0
        // }, {
        //   id: 11,
        //   index: '/estEdit',
        //   content: '修改',
        //   showFlag: 0
        }, {
          id: 12,
          index: '/estEst',
          content: '评估',
          showFlag: 0
        }, {
          id: 13,
          index: '/esTexamine',
          content: '审核',
          showFlag: 0
        }, {
          id: 14,
          index: '/esTauthorize',
          content: '审定',
          showFlag: 0
        }, {
          id: 15,
          index: '/estSave',
          content: '存档',
          showFlag: 0
        }]
      }, {
        id: 120,
        index: '',
        content: '系统管理',
        showFlag: 0,
        children: [{
          id: 121,
          index: '/estPerCenter',
          content: '人事中心',
          showFlag: 0
        }]
      }],
      // old
      tabType: 'tabA',
      companyName: '',
      // tabData
      tabData: [
        {
          tabTitle: '环评审核',
          tabIndex: 'tabA',
          tabType: 'table',
          tableNames: [
            '文件名称',
            '项目名称',
            '建设单位',
            '环评类别',
            '行业类别'
          ],
          rowItems: [
            'fileName',
            'constructionUnits',
            'companyName',
            'constructionProject',
            'nationalEconomy'
          ],
          api: {
            add: 'cdSummaryTableAdd',
            enquiry: 'cdSummaryTableEnquiry',
            update: 'cdSummaryTableUpdate',
            delete: 'cdSummaryTableDelete',
            extraParam: {
              category: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
      ],
      tabDataCrt: {},
      tableNamesS: [
        '文件名称',
        '项目名称'
        // '建设单位',
        // '环评类别',
        // '行业类别'
      ],
      rowItemsS: [
        'fileName',
        'constructionUnits'
        // 'companyName',
        // 'constructionProject',
        // 'nationalEconomy'
      ],
      tableNamesD: [
        '文件名称',
        '项目名称',
        '建设单位',
        '环评类别',
        '行业类别'
      ],
      rowItemsD: [
        'fileName',
        'constructionUnits',
        'companyName',
        'constructionProject',
        'nationalEconomy'
      ],
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true,
      jindu: false,
      percentage: 10,
      text1: '',
      importFlag: false,
      extaParam: {},
      wordInfo: false,
      textarea: '',
      detailsRow: {},
      showDetailsDialogFlag: false,
      showProtectionCheckDialogFlag: false,
      protectionCenter: '',
      protectionTable: {
        title: ['title1', 'title2', 'title3', 'title4', 'title5'],
        table: [
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5']
        ]
      }
    }
  },
  mounted () {
    this.onShowPageType = this.$route.query.pt
    if (this.$route.query.ph && this.$route.query.pw) {
      this.unreadableTips = '加载中……'
      api.login({
        phoneNumber: this.$route.query.ph,
        password: this.$route.query.pw
      }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          sessionStorage.setItem('qs_phone', this.$route.query.ph)
          sessionStorage.setItem('qs_token', res.data.token)
          sessionStorage.setItem('qs_user_name', res.data.name)
          // this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
          // this.getTabData()
          this.phone = this.$route.query.ph
          this.userName = res.data.name
          console.log(sessionStorage.getItem('qs_phone') || null)
          this.getAuth()
        } else {
          this.unreadableTips = res.message
        }
      })
    } else {
      this.unreadableTips = '未登录，请先登录'
    }
  },
  methods: {
    // coe
    getAuth () {
      api.jcJurisdictionSearch({
        kind: 1,
        staffing: 1,
        phone: this.phone
      }).then(res => {
        console.log(res)
        if (res.code === 200) {
          var authStr = res.data.list[0].jurisdiction
          var authArr = authStr.split(',')
          this.enterableInnerList = []
          this.estActiveStepLabel = []
          this.estActiveStepPath = []
          this.estSysActiveStepLabel = []
          this.estSysActiveStepPath = []
          authArr.forEach(gohh => {
            this.menuList.forEach(item => {
              if (item.content === gohh) {
                item.showFlag = 1
              } else if (item.children) {
                item.children.forEach(subitem => {
                  if (subitem.content === gohh) {
                    subitem.showFlag = 1
                  } else if (subitem.children) {
                    subitem.children.forEach(supitem => {
                      if (supitem.content === gohh) {
                        supitem.showFlag = 1
                      }
                    })
                  }
                })
              }
            })
            var innerList = ['在线评估', '系统管理']
            if (innerList.indexOf(gohh) > -1) {
              this.enterableInnerList.push(gohh)
            }
            if (this.estAllStepLabel.indexOf(gohh) > -1) {
              this.estActiveStepLabel.push(gohh)
              this.estActiveStepPath.push(this.estAllStepPath[this.estAllStepLabel.indexOf(gohh)])
            }
            if (this.estSysAllStepLabel.indexOf(gohh) > -1) {
              this.estSysActiveStepLabel.push(gohh)
              this.estSysActiveStepPath.push(this.estSysAllStepPath[this.estSysAllStepLabel.indexOf(gohh)])
            }
          })
          var estActiveStepLabelTemp = []
          this.estAllStepLabel.forEach((sl, sli) => {
            if (this.estActiveStepLabel.indexOf(sl) > -1) {
              estActiveStepLabelTemp.push(sl)
            }
          })
          this.estActiveStepLabel = estActiveStepLabelTemp
          var estActiveStepPathTemp = []
          this.estAllStepPath.forEach((sp, spi) => {
            if (this.estActiveStepPath.indexOf(sp) > -1) {
              estActiveStepPathTemp.push(sp)
            }
          })
          var estSysActiveStepLabelTemp = []
          this.estSysAllStepLabel.forEach((sl, sli) => {
            if (this.estSysActiveStepLabel.indexOf(sl) > -1) {
              estSysActiveStepLabelTemp.push(sl)
            }
          })
          this.estSysActiveStepLabel = estSysActiveStepLabelTemp
          var estSysActiveStepPathTemp = []
          this.estSysAllStepPath.forEach((sp, spi) => {
            if (this.estSysActiveStepPath.indexOf(sp) > -1) {
              estSysActiveStepPathTemp.push(sp)
            }
          })
          this.estActiveStepPath = estActiveStepPathTemp
          this.estSysActiveStepPath = estSysActiveStepPathTemp
          console.log('this.menuList', this.menuList)
          console.log('this.enterableInnerList', this.enterableInnerList, authArr)
          console.log('this.estActiveStepLabel', this.estActiveStepLabel, this.estActiveStepPath)
          console.log('this.estSysActiveStepLabel', this.estSysActiveStepLabel, this.estSysActiveStepPath)
          this.goMainInner(this.onShowPageType, res.data.tips)
        } else {
          this.unreadableTips = res.message
        }
      })
    },
    goMainInner (pageType, unreadableTips) {
      if (this.enterableInnerList.indexOf(pageType) > -1) {
        // this.mainInnerType = pageType
        // this.showInnerPage = true
        switch (pageType) {
          case '在线评估':
            this.activeMenuList = [this.menuList[0]]
            this.activeHomePage = '/estOverview'
            break
          case '系统管理':
            this.activeMenuList = [this.menuList[1]]
            // this.activeMenuList = [this.menuList[5]]
            this.activeHomePage = '/estPerCenter'
            break
        }
        this.showPageF = true
        console.log('activeHomePage', this.activeHomePage, this.showPageF)
        // this.$router.push({
        //   path: this.activeHomePage,
        //   query: {}
        // })
      } else {
        // this.unreadableTips = '您没有进入该页面的权限，请联系管理员处理。开启权限后，重启应用即可进入'
        this.unreadableTips = unreadableTips
        this.showPageF = false
      }
    },
    goToPage (path) {
      if (this.$route.path !== path) {
        this.$router.push('path')
      }
    },
    // old
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              jsonData: item.jsonData,
              longitude: item.longitude,
              latitude: item.latitude,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    // handleRefresh () {
    //   console.log(this.tabType)
    //   this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
    //   this.isRefresh = false
    //   this.$nextTick(function () {
    //     this.isRefresh = true
    //     this.pageNo = 1
    //     this.getTabData()
    //   })
    // },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    closeIF () {
      this.importFlag = false
    },
    addRow () {
      this.importFlag = true
      // var bianliang = setInterval(() => {
      //   this.percentage = this.percentage + 1
      //   if (this.percentage >= 99) {
      //     clearInterval(bianliang)
      //   }
      // }, 1000)
    },
    handleSuccess () {
      this.$toast.text('上传成功')
      this.getTabData()
    },
    checkUpload () {
      this.$refs.uploadRef.doUpload()
    },
    closeWI () {
      this.wordInfo = false
    },
    addTerm () {
      this.wordInfo = true
    },
    determine () {
      api.cdSummaryTableAdd({
        textarea: this.textarea
      }).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$toast.text('确定成功')
          // this.$message({
          //   message: '确定成功',
          //   type: 'success'
          // })
        }
      })
    },
    editRow (row) {
      // row.editFlag = true
      this.percentage = 0
      this.jindu = true
      var bianliang = setInterval(() => {
        this.percentage = this.percentage + 1
        if (this.percentage >= 99) {
          clearInterval(bianliang)
        }
      }, 1000)
      api.cdSummaryTableDownload({
        id: row.id
      }).then(res => {
        console.log(res)
        if (res.code === 200) {
          window.open(res.data)
          this.percentage = 100
          clearInterval(bianliang)
          setTimeout(() => {
            this.jindu = false
          }, 1000)
        } else {
          clearInterval(bianliang)
          this.text1 = res.message
        }
        // if (res.code === 40001) {
        //   this.jindu = false
        // }
      })
    },
    saveRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        var savePusher = {
          id: row.id,
          ...this.tabDataCrt.api.extraParam
        }
        this.tabDataCrt.rowItems.forEach(rowItem => {
          console.log(row, rowItem, row[rowItem])
          savePusher[rowItem] = row[rowItem] || ''
        })
        api[this.tabDataCrt.api.update](savePusher).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    showDetails (row) {
      console.log(row)
      this.detailsRow = row
      this.showDetailsDialogFlag = true
    },
    showProtectionCheck (row) {
      console.log(row)
      if (row.jsonData) {
        this.showProtectionCheckDialogFlag = true
        this.protectionCenter = [Number(row.longitude), Number(row.latitude)]
        this.protectionTable = JSON.parse(row.jsonData)
        setTimeout(() => {
          this.$refs.protectionMap.addGraphics()
        }, 3000)
      } else {
        this.$toast.text('该项目没有保护目标')
      }
    }
  },
  components: {
    estPage,
    estSystemPage
    // protectionMap
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.homepage{
  width: 100%;
  div{
    border-radius: 2px;
  }
}
.coe-home{
  z-index: 0;
  height: 100%;
  overflow-y: auto;
  background: #082567;
  .user-unreadable{
    width: 100%;
    height: 100%;
    .tips-box{
      width: 80%;
      height: 100%;
      margin: auto;
      font-size: 24px;
      font-family: "Microsoft Yahei","Hiragino Sans GB","Helvetica Neue",Helvetica,tahoma,arial,"WenQuanYi Micro Hei",Verdana,sans-serif;
      color: lightblue;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .est-page{
    width: 100%;
    height: 100%;
  }
  // old
  .user-box {
    font-family: "Microsoft Yahei","Hiragino Sans GB","Helvetica Neue",Helvetica,tahoma,arial,"WenQuanYi Micro Hei",Verdana,sans-serif;
    position: absolute;
    top: 0;
    width: 100%;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // margin: auto!important;
    color: lightblue;
    padding: 12px 0;
    // display: flex;
    // flex: 0 0 auto;
    text-align: center;
    .action {
      // text-align: right;
      .my-name {
        margin: 4px 0;
        // font-size: 16px;
        font-size: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // width: 62px;
        line-height: 1;
      }
      .el-tag {
        cursor: pointer;
      }
      .about-us {
        font-size: 12px;
        font-weight: normal;
        color: lightblue;
      }
    }
  }
  .index-main {
    width: 100%;
    height: 100%;
    background-color: #082567;
    .index-main-center-box {
      width: 100%;
      height: 30%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      justify-content: space-around;
      .box-btn {
        font-family: "Microsoft Yahei","Hiragino Sans GB","Helvetica Neue",Helvetica,tahoma,arial,"WenQuanYi Micro Hei",Verdana,sans-serif;
        width: 50vw;
        // height: 10vw;
        // border: lightblue 1px solid;
        text-align: center;
        .box-btn-icon {
          font-size: 50vw;
          // width: 100%;
          color: lightblue;
        }
        .box-btn-label {
          font-size: 8vw;
          // color: lightblue;
          color: goldenRod;
        }
      }
    }
  }
}
</style>
